import {router} from '../router'

const normalizePath = path => path.replace(/\/+$/, '') || path

export const goBack = () => {
	// location.key is always "default" on the first page in a session (https://github.com/remix-run/react-router/issues/9301#issuecomment-1384665557)
	const hasHistory = router.state.location.key !== 'default'
	const hasBackground = !!router.state?.location?.state?.background

	router.navigate(hasHistory || hasBackground ? -1 : '/')
}

export const closeModal = () => {
	const {background, modalDepth} = router.state.location.state ?? {}

	// Happy path: When a modal is opened via internal links or clicks
	if (Number.isInteger(modalDepth) && modalDepth > 0) {
		router.navigate(-modalDepth)
		return
	}

	// Edge case: Modal depth is not preserved when it's opened via either:
	// - directly visiting the modal route
	// - modal route opened in a new tab
	router.navigate(background || '/', {replace: true})
}

// This is a rough mirror of `/web/src/actions/routing.js`
// so the bridge consumers can use them agnostically
export const navigateModal = async (modalLink, {overrideBackgroundPath, state = {}, replace} = {}) => {
	let currentLocation = router.state.location
	const currentBackgroundLocation = currentLocation?.state?.background
	const isCurrentlyInModal = Boolean(currentBackgroundLocation)
	const newBackgroundPath = overrideBackgroundPath ? normalizePath(overrideBackgroundPath) : null
	const currentPath = currentLocation?.pathname ? normalizePath(currentLocation.pathname) : null
	let shouldReplace = Boolean(replace && isCurrentlyInModal)

	if (newBackgroundPath) {
		if (isCurrentlyInModal) {
			await router.navigate(newBackgroundPath, {replace: true})
			currentLocation = router.state.location
		}

		if (!isCurrentlyInModal && currentPath !== newBackgroundPath) {
			await router.navigate(newBackgroundPath)
			currentLocation = router.state.location
		}

		shouldReplace = false
	}

	const background = newBackgroundPath ? currentLocation : currentBackgroundLocation || currentLocation
	const currentModalDepth = currentLocation?.state?.modalDepth ?? 0
	const options = {
		replace: shouldReplace,
		state: {
			...state,
			background,
			modalDepth: shouldReplace ? Math.max(currentModalDepth, 1) : currentModalDepth + 1,
		},
	}

	router.navigate(modalLink, options)
}
